const initPanel = ( panel ) => {
	const links = panel.querySelectorAll( 'a' );
	if ( links.length == 1 ) {
		const a_link = links[ 0 ];
		const url = a_link.href;
		a_link.parentElement.classList.add( 'simulated-link' );
		a_link.replaceWith( a_link.textContent );

		const link = document.createElement( 'a' );
		link.classList.add( 'panel-link' );
		link.href = url;

		while ( panel.firstChild ) {
			link.appendChild( panel.firstChild );
		}
		panel.appendChild( link );
		panel.classList.add( 'has-panel-link' );
	}
};

const initPanelColumn = ( container ) => {
	const panelItems = container.querySelectorAll( ':scope > *' );
	if ( panelItems.length < 1 ) {
		return;
	}

	panelItems.forEach( panel => {
		initPanel( panel );
	});
};

const initCGAPanelColumns = () => {
	const panelColumns = document.querySelectorAll( '.cga-panel-columns.display-as-column-blocks' );
	if ( panelColumns.length < 1 ) {
		return;
	}

	panelColumns.forEach( container => {
		initPanelColumn( container );
	});
};

export { initCGAPanelColumns };